export class Document {
    documentID: number;
    projectID: number;
    name: string;
    link: string;
}
/*
{
        "documentID": 1,
        "projectID": 1,
        "name": "Brochure",
        "link": "http://api.victorcalls.com/api/Project/1/Document/1"
    },


*/
